(function (factory) {
    if (typeof define === 'function' && define.amd) {
        define(['jquery'], factory);
    } else if (typeof module === 'object' && module.exports) {
        module.exports = factory(require('jquery'));
    } else {
        factory(window.jQuery);
    }
}(function ($) {
    var ui = $.summernote.ui;
    var dom = $.summernote.dom;
    var imageWidthPlugin = function (context) {
        var self = this;
        var options = context.options;
        var lang = options.langInfo;
        var editable = context.layoutInfo.editable;

        context.memo('button.imageWidth100', function () {
            return ui.button({
                contents: '<span class="note-fontsize-10">100%</span>',
                tooltip: lang.imageWidth.width100,
                click: function(event) {
                    var $img=$(editable.data('target'));
                    $img.removeClass('width-50 width-25').addClass("width-100");
                    $img.css("width", "100%");
                    context.invoke('editor.afterCommand');
                }
            }).render();
        });
        context.memo('button.imageWidth50', function () {
            return ui.button({
                contents: '<span class="note-fontsize-10">50%</span>',
                tooltip: lang.imageWidth.width50,
                click: function(event) {
                    var $img=$(editable.data('target'));
                    $img.removeClass('width-100 width-25').addClass("width-50");
                    $img.css("width", "50%");
                    context.invoke('editor.afterCommand');
                }
            }).render();
        });
        context.memo('button.imageWidth25', function () {
            return ui.button({
                contents: '<span class="note-fontsize-10">25%</span>',
                tooltip: lang.imageWidth.width25,
                click: function(event) {
                    var $img=$(editable.data('target'));
                    $img.removeClass('width-100 width-50').addClass("width-25");
                    $img.css("width", "25%");
                    context.invoke('editor.afterCommand');
                }
            }).render();
        });
    };

    $.extend(true, $.summernote, {
        plugins: {
            imageWidth: imageWidthPlugin
        },
        options: {
            popover: {
                imageWidth: [
                    ['imageWidth', ['width100', 'width50', 'width25']]
                ]
            }
        },
        lang: {
            'en-US':{
                imageWidth:{
                    width100:'Resize Full',
                    width50:'Resize Half',
                    width25:'Resize Quarter',
                }
            }
        }
    });
}));